<div class="ui-g">
  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'storeConfigurationList.configuration' | translate }}</h1>
  </div>

  <div class="ui-g-12 ui-lg-6 text-right">
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
    <button pButton (click)="save()" type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}"></button>
  </div>

  <div class="clearfix"></div>

  <div class="card ui-g">
    <div class="ui-g-12">
      <div class="ui-g ui-g-nopad">
        <div class="ui-g-6 form-control">
          <span class="label">{{ 'storeConfigurationList.division_sales_network' | translate }}</span>
          <p-dropdown [style]="{'width':'100%'}" [options]="listDivisionSalesNetwork" [filter]="true" [(ngModel)]="selectedDivisionSalesNetwork"
            (onChange)="onDivisionChange()" placeholder="{{'common.select_something' | translate}}"
            [showClear]="true" [disabled]="selectedStore != null" [autoDisplayFirst]="false"></p-dropdown>
        </div>
        <div class="ui-g-6 form-control">
          <span class="label">{{ 'storeConfigurationList.store' | translate }}</span>
          <p-dropdown [style]="{'width':'100%'}" [options]="listStore" [filter]="true" [(ngModel)]="selectedStore"
            (onChange)="onStoreChange()" placeholder="{{'common.select_something' | translate}}"
            [showClear]="true" [disabled]="selectedDivisionSalesNetwork != null" [autoDisplayFirst]="false"></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="card ui-g" style="width: 100%;">
    <div class="ui-g-12">
      <div class="ui-g-6">
        <h2>{{ 'storeConfigurationList.periods' | translate }}</h2>
      </div>
      <div class="ui-g-6 text-right">
        <button pButton type="button" class="k-generic-btn" icon="fa fa-plus" iconPos="left"
          (click)="addPeriod()" label="{{ 'storeConfigurationList.add_period' | translate }}"></button>
      </div>
    </div>

    <div class="ui-g-12">
      <p-table [value]="periods" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'common.id' | translate }}</th>
            <th>{{ 'storeConfigurationList.date_start' | translate }}</th>
            <th>{{ 'storeConfigurationList.date_end' | translate }}</th>
            <th>{{ 'storeConfigurationList.validity_status' | translate }}</th>
            <th>{{ 'storeConfigurationList.front_end' | translate }}</th>
            <th>{{ 'storeConfigurationList.promotion' | translate }}</th>
            <th>{{ 'storeConfigurationList.customer_system' | translate }}</th>
            <th>{{ 'storeConfigurationList.loyalty_system' | translate }}</th>
            <th>{{ 'storeConfigurationList.analytics_system' | translate }}</th>
            <th>{{ 'storeConfigurationList.backoffice_system' | translate }}</th>
            <th>{{ 'storeConfigurationList.couponing_system' | translate }}</th>
            <th>{{ 'campaign.touchpoint' | translate }}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-period>
          <tr>
            <td>{{ period.id }}</td>
            <td>{{ formatDateForDisplay(period.date_start) }}</td>
            <td>{{ formatDateForDisplay(period.date_end) }}</td>
            <td>
              <div class="status-badge-table" [ngClass]="'badge-' + getStatus(period).toLowerCase()">
                <span class="status-dot" [ngClass]="'dot-' + getStatus(period).toLowerCase()"></span>
                {{ 'status.' + getStatus(period).toLowerCase() | translate }}
              </div>
            </td>
            <td>{{ period.front_end_name }}</td>
            <td>{{ period.promotion_name }}</td>
            <td>{{ period.customer_name }}</td>
            <td>{{ period.loyalty_name }}</td>
            <td>{{ period.analytics_name }}</td>
            <td>{{ period.backoffice_name }}</td>
            <td>{{ period.couponing_name }}</td>
            <td>{{ period.ochannel_code }}</td>
            <td>
              <button *ngIf="getStatus(period) !== 'expired'" pButton type="button" icon="fa fa-pencil" class="ui-button-success"
                (click)="editPeriod(period)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<app-store-configuration-period-form
  *ngIf="showPeriodDialog"
  [period]="periodToEdit"
  [existingPeriods]="periods"
  [(showDialog)]="showPeriodDialog"
  (periodSaved)="onPeriodSaved($event)"
  (periodCancelled)="onPeriodCancelled()"
></app-store-configuration-period-form>



// WEBPACK FOOTER //
// ./src/app/views/administration/store-configuration/store-configurationForm.html